import React from 'react'
import { SecondaryButton, Text } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { IconSystemSearchSimilar } from '@moonpig/launchpad-assets'
import { useExperiment } from '@moonpig/web-core-eppo/browser'
import { useLocaleText } from '../../locale/moreLikeThis.locale'
import {
  trackGAEvent,
  createGenericSelectContentEvent,
} from '@moonpig/web-core-analytics'
import { colorValue } from '@moonpig/launchpad-theme'

const BUTTON_HEIGHT = '40px'
const BUTTON_WIDTH = '150px'

type Props = {
  className?: string
}

const StyledSecondaryButton = styled(SecondaryButton)`
  position: absolute;
  bottom: 8px;
  left: 8px;
  border: 1px;
  border-radius: 50px;
  height: ${BUTTON_HEIGHT};
  max-height: ${BUTTON_HEIGHT};
  max-width: ${BUTTON_WIDTH};

  ${s({
    color: 'colorTextHeadline',
    borderColor: 'colorBlack10',
    bgcolor: 'colorBlack00',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    zIndex: 2,
    pl: 4,
    pr: 5,
    py: 0,
    minHeight: 0,
    boxShadow: 2,
  })}

  svg {
    color: currentcolor;
  }
  
  &:not(:disabled):hover,
  &:not(:disabled):active {
    ${s({
      color: 'colorTextHeadline',
      bgcolor: 'colorInteractionControlHoverFill',
      boxShadow: 2,
    })}
  }

    &:not(:disabled, .loading):focus {
    background-color: ${colorValue('colorBlack00')};
    color: currentcolor;
    }

`

const handleClick = () => {
  const moduleMoreLikeThis = document.getElementById('module-more-like-this')

  moduleMoreLikeThis?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  trackGAEvent(
    createGenericSelectContentEvent({
      eventCategory: 'product details',
      eventAction: 'navigate to',
      eventLabel: 'more like this',
    }),
  )
}

export const MoreLikeThisButton = ({ className }: Props) => {
  const moreLikeThisExperiment = useExperiment('search-use-more-like-this-v3', {
    fallback: 'control',
  })
  const showMoreLikeThis =
    moreLikeThisExperiment === 'carousels' || moreLikeThisExperiment === 'tabs'

  const localiseText = useLocaleText()

  if (!showMoreLikeThis) return null

  return (
    <StyledSecondaryButton
      className={className}
      leadingIcon={<IconSystemSearchSimilar />}
      onClick={handleClick}
    >
      <Text
        color="colorTextHeadline"
        typography={{ xs: 'typeMobileBodyLabel', md: 'typeDesktopBodyLabel' }}
      >
        {localiseText('more_like_this.title')}
      </Text>
    </StyledSecondaryButton>
  )
}
